import {ViewerEndVo} from '../../common/shared/api/gateway/viewer/ViewerEndVo.interface';
import {Maybe, User, ViewerEnd} from '../generated/types';
import {createContentRecommendGroup} from './ContentRecommendGroup';
import {createDisplayAd} from './DisplayAd';
import {createOnIssue} from './OnIssue';
import {createPreviewCommentItem} from './PreviewCommentItem';
import {createSeries} from './Series';
import {createSingle} from './Single';
import {createSortOption} from './SortOption';

export function createViewerEnd(
  userInfo: Maybe<User>,
  {
    rating_count,
    rating_sum,
    comment_count,
    display_ad,
    like_on,
    alarm_on,
    on_issue,
    content_recommend,
    next_item,
    preview,
    related_series,
  }: ViewerEndVo
): ViewerEnd {
  return {
    ratingCount: rating_count,
    ratingSum: rating_sum,
    commentCount: comment_count,
    displayAd: display_ad && createDisplayAd(display_ad),
    likeOn: like_on,
    alarmOn: alarm_on,
    onIssue: createOnIssue(on_issue),
    contentRecommendGroup:
      content_recommend &&
      createContentRecommendGroup(userInfo, {
        contentRecommendVo: content_recommend,
      }),
    nextItem: next_item && createSingle(next_item),
    viewerEndPreviewComment: preview && {
      sortOpt: createSortOption({sortOptVo: preview.sort_opt}),
      comment: createPreviewCommentItem(preview.comment),
    },
    relatedSeries: related_series?.item && createSeries(related_series.item),
  };
}
